import React from 'react';
import { Header } from 'semantic-ui-react';

import { Fecha } from 'src/componentes';
import TarjetaObservacion from './TarjetaObservacion';
import { TarjetaPropsComunes } from './tipos';

interface Props extends TarjetaPropsComunes {
    readonly habilitadosParaClases: boolean;
    readonly habilitadosParaMaterial: boolean;
}

const TarjetaCompromisoDePago: React.FunctionComponent<Props> = props => {
    const {
        fechaAdicional,
        habilitadosParaClases,
        habilitadosParaMaterial,
        observaciones,
        ...resto
    } = props;

    return (
        <TarjetaObservacion
            {...resto}
            elevado
            titulo='Compromiso de pago'
            observaciones={
                <React.Fragment>
                    {fechaAdicional && (
                        <Header as='h5'>
                            Se compromete a pagar el <Fecha fecha={fechaAdicional} />
                        </Header>
                    )}
                    {observaciones}
                </React.Fragment>
            }
            mensajeExtra={
                (habilitadosParaClases || habilitadosParaMaterial) && (
                    <div>
                        {habilitadosParaClases && (
                            <div>
                                Los alumnos pueden seguir{' '}
                                <b>
                                    ingresando a clases hasta el <Fecha fecha={fechaAdicional!} />
                                </b>
                                .
                            </div>
                        )}
                        {habilitadosParaMaterial && (
                            <div>
                                Los alumnos pueden seguir{' '}
                                <b>
                                    recibiendo material hasta el <Fecha fecha={fechaAdicional!} />
                                </b>
                                .
                            </div>
                        )}
                    </div>
                )
            }
        />
    );
};

export default TarjetaCompromisoDePago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Observaciones/TarjetaCompromisoDePago.tsx